<article class="row" [class.locked]="event.betsCount == 0" [class.contentV2]="viewConfigurations.useMobileViewWithTopMenu">
    <div class="flex-full-width">

        <div class="col col1" (click)="showDetail(event)">
            <div class="time-code-wrap" [class.wide]="languageForBetradar.includes('en')">
                <span class="time">{{event.eventTime}}</span>
                <span class="code" *ngIf="!viewConfigurations.hideEventCodeInEvent">{{event.code}}</span>
                <!-- <span class="code">{{event.code}}</span> -->
                <ng-container *ngIf="viewConfigurations.hideEventCodeInEvent">
                    <i *ngIf="event.mappingType == eventMappingTypeEnum.StandardEvent" class="icon-ex-sm s-icon-{{getSportName(event.sportId)}} sportid-{{event.sportId}}"></i>
                    <i class="icon-width sporticon icon-ex-sm sporticon-all" *ngIf="event.mappingType == eventMappingTypeEnum.EventOfDay"><sub>{{dynamicTranslations.specialOfferEventsShorcutEventOfDay}}</sub></i>
                    <i class="icon-width sporticon icon-ex-sm sporticon-all" *ngIf="event.mappingType == eventMappingTypeEnum.SuperBetEvent"><sub>{{dynamicTranslations.specialOfferEventsShorcutSuperBet}}</sub></i>
                </ng-container>
            </div>

            <div class="region-flag-wrap" *ngIf="pageType === pageTypeEnum.Soon || pageType === pageTypeEnum.MostPopular">
                <div class="region-flag reg-{{regionNameMap.getRegionName(event.regionId)}} region-{{event.regionId}}"></div>
                <!-- <div class="region-flag reg-{{event.regionId}}"></div> -->
                <div class="small-text">{{event.regionName | slice:0:3}}</div>
            </div>

            <ng-container *ngIf="!viewConfigurations.hideEventCodeInEvent">
                <div class="super-bet" *ngIf="event.mappingType == eventMappingTypeEnum.SuperBetEvent">{{dynamicTranslations.specialOfferEventsShorcutSuperBet}}</div>
                <div class="super-bet" *ngIf="event.mappingType == eventMappingTypeEnum.EventOfDay">{{dynamicTranslations.specialOfferEventsShorcutEventOfDay}}</div>
            </ng-container>


            <div class="event-name">
              <div class="home-away">
                <ng-container *ngIf="event.homeTeam != null || event.awayTeam !==null; else outright;">
                  <span class="home">{{event.homeTeam}}</span>
                  <span class="away">{{event.awayTeam}}</span>
                </ng-container>
                <ng-template #outright>
                  <span>{{event.eventName}}</span>
                </ng-template>

              </div>
              <div class="superbet-required-items" *ngIf="event.mappingType == eventMappingTypeEnum.SuperBetEvent && !viewConfigurations.useMobileViewWithTopMenu">
                {{requiredNonSbItems}}+1
              </div>
                <!-- <label *ngIf="event.isOffline"> - Offline</label> -->
            </div>


            <div class="time-id-wrap">
                <a class="stat" (click)="$event.stopPropagation();" href="https://s5.sir.sportradar.com/admiralbeteeuof/{{languageForBetradar}}/match/{{event.betRadarEventId}}" title="Statistic" [attr.aria-label]="'Statistic'" onclick="window.open(this.href, 'newwindow', 'width=1210, height=700'); return false;" onkeypress="window.open(this.href, 'newwindow', 'width=1210, height=700'); return false; $event.stopPropagation();">
                    <i class="statistic-chart icon-chart-bar"></i>
                </a>
                <!-- <div class="time-wrap">
                    <span class="time">{{event.eventDate | slice: 0:3 }} {{event.eventTime}}</span>
                </div> -->
                <!-- <span class="id">{{event.code}}</span> -->
            </div>

            <!-- <div class="cash-back" *ngIf="event.cashBackEnabled" title="Casheback">
                <span class="cash-icon"></span>
            </div> -->
            <!-- <app-head-to-head-widget></app-head-to-head-widget> -->
            <div class="icon-comp" *ngIf="event.betRadarEventId && viewConfigurations.showWidgetsOnSite && event.specialOfferType !== specialOfferTypeEnum.Outrights && enviroment.viewConfiguration === siteViewConfigurationEnum.UGANDA" (click)="headToHeadWidget(); $event.stopPropagation();">
                <span class="sporticon icon-sm sporticon-chart"></span>

                <div class="statistic-widget-wrap" (click)="$event.stopPropagation();">
                  <!-- <app-head-to-head-widget *ngIf="showH2Hwidget" [betRadarEventId]='event.betRadarEventId'></app-head-to-head-widget> -->
                </div>
              <!-- <div *ngIf="event.betRadarEventId" class="icon icon-div" (click)="headToHeadWidget(); $event.stopPropagation();">
              </div> -->
            </div>
            <div class="icon-comp" *ngIf="event.betRadarEventId && viewConfigurations.showWidgetsOnSite && event.specialOfferType !== specialOfferTypeEnum.Outrights && enviroment.viewConfiguration === siteViewConfigurationEnum.NIGERIA" (click)="$event.stopPropagation();">
              <a class="stat" (click)="$event.stopPropagation();" href="https://s5.sir.sportradar.com/winnersgoldenbet/{{languageForBetradar}}/match/{{event.betRadarEventId}}" title="Statistic" [attr.aria-label]="'Statistic'" onclick="window.open(this.href, 'newwindow', 'width=1210, height=700'); return false;" onkeypress="window.open(this.href, 'newwindow', 'width=1210, height=700'); return false; $event.stopPropagation();">
                <span class="sporticon icon-sm sporticon-chart"></span>
            </a>

          </div>

            


            <!-- commneted because notifications are not redy for deploy -->
            <!-- <div *ngIf="isUserLogedIn" class="icon icon-div" (click)="setEventForMessaging(event);  $event.stopPropagation();" >
              <span class="sporticon icon-sm sporticon-{{event.isNotificationEnabled ? 'star' : 'star-border'}}"></span>
            </div> -->
        </div>
        <!-- <div class="custom-radio">
          <input type="checkbox" id=event.id name="notificationTicketDialog"   (change)="setEventForMessaging(event)" [checked]="event.isNotificationEnabled" >
          <label for=event.id ></label>
        </div> -->
        <div class="col col2" *ngIf="event.eventType == eventTypeEnum.HeadToHead">

            <ng-container *ngFor="let betTypeGroupingTemplateItem of betTypeGroupingTemplateItems; let i = index">
              <ng-container *ngIf="(selectedBetsByBetTypeId && selectedBetsByBetTypeId[betTypeGroupingTemplateItem.betTypeId]?.bet) || (betsAndOutcomes?.bets && betsAndOutcomes?.bets[betTypeGroupingTemplateItem.betTypeId]); let bet; else emptyBet">
                  <div class="bet-type-col">
                      <ng-container *ngFor="let betTypeOutcome of betTypeGroupingTemplateItem.betTypeOutcomes; let j = index;">
                          <ng-container *ngIf="j<3">

                              <!-- <h2>{{j}}</h2> -->
                              <span class="sbv" *ngIf="bet.sbv && ((j==0 && betTypeGroupingTemplateItem.betTypeOutcomes.length > 2) || (j==1 && betTypeGroupingTemplateItem.betTypeOutcomes.length < 3) )" [class.clickable]="betsAndOutcomes?.sbvsForBetTypes[betTypeGroupingTemplateItem.betTypeId]?.length > 1">
                                <div class="sbv" *ngIf="!bet.useSbvHandicapPipe" title="{{bet.sbv}}" >{{bet.sbv}}</div>
                                <div class="sbv" *ngIf="bet.useSbvHandicapPipe" title="{{bet.sbv | handicapSbv}}" >{{bet.sbv | handicapSbv}}</div>

                                <mat-select disableOptionCentering *ngIf="betTypeGroupingTemplateItem.sbvDisplayType != -1  && betsAndOutcomes?.sbvsForBetTypes[betTypeGroupingTemplateItem.betTypeId] && betsAndOutcomes?.sbvsForBetTypes[betTypeGroupingTemplateItem.betTypeId].length > 1" [value]="bet.sbv" panelClass="sbv-select-wrap">
                                  <mat-option *ngFor="let sbvWithBetId of betsAndOutcomes?.sbvsForBetTypes[betTypeGroupingTemplateItem.betTypeId]" [value]="sbvWithBetId.sbv" (click)="changeSbv(betTypeGroupingTemplateItem.betTypeId, sbvWithBetId.betId)" >
                                    <div class="sbv" *ngIf="!bet.useSbvHandicapPipe">{{sbvWithBetId.sbv}}</div>
                                    <div class="sbv" *ngIf="bet.useSbvHandicapPipe">{{sbvWithBetId.sbv | handicapSbv}}</div>
                                  </mat-option>
                                </mat-select>
                              </span>
                              <ng-container *ngTemplateOutlet="outcomes; context:{outcomesList: selectedBetsByBetTypeId && selectedBetsByBetTypeId[betTypeGroupingTemplateItem.betTypeId] ? selectedBetsByBetTypeId[betTypeGroupingTemplateItem.betTypeId].betOutcomes : betsAndOutcomes.betOutcomes[bet.id], betTypeOutcome: betTypeOutcome}">
                              </ng-container>
                              <ng-template #outcomes let-outcomesList="outcomesList" let-betTypeOutcome="betTypeOutcome">
                                <ng-container *ngIf="outcomesList
                                && outcomesList[betTypeOutcome.id]?.length > 0
                                && outcomesList[betTypeOutcome.id][0].isPlayable
                                && outcomesList[betTypeOutcome.id][0].odd > 1; else emptyOutcome">
                                    <span [attr.data-market]="outcomesList[betTypeOutcome.id][0].name" [ngClass]="{'single-outcome': bet.sbv && betTypeGroupingTemplateItem.betTypeOutcomes.length === 1, 'selected': outcomesList[betTypeOutcome.id][0].isSelected}"
                                      (click)="toggleEventOutcome(event, bet, outcomesList[betTypeOutcome.id][0], betTypeOutcome.name, betTypeGroupingTemplateItem.betTypeName)" title="{{betTypeOutcome.descriptions}}" [@.disabled]="isAnimationDisabled">
                                      <ng-container *ngIf="bet.sbv && betTypeGroupingTemplateItem.betTypeOutcomes.length === 1">
                                        <div class="sbv" *ngIf="!bet.useSbvHandicapPipe" title="{{bet.sbv}}" >{{bet.sbv}}</div>
                                        <div class="sbv" *ngIf="bet.useSbvHandicapPipe" title="{{bet.sbv | handicapSbv}}" >{{bet.sbv | handicapSbv}}</div>
                                      </ng-container>
                                      <div [@blink]="outcomesList[betTypeOutcome.id][0].odd">
                                        {{outcomesList[betTypeOutcome.id][0].odd | odd}}
                                      </div>
                                      <!-- <div [@blink]="outcomesList[betTypeOutcome.id][0].odd">
                                      </div> -->
                                    </span>
                                </ng-container>
                              </ng-template>
                              <ng-template #emptyOutcome>
                                  <span class="locked" [attr.data-market]="betTypeOutcome.mobileShowType == betTypeOutcomeShowTypeEnum.BTOShortName? betTypeOutcome.shortName: betTypeOutcome.name">
                                    <i class="icon icon-ex-sm icon-lock"></i>
                                  </span>
                              </ng-template>
                          </ng-container>

                      </ng-container>

                  </div>

              </ng-container>

              <ng-template #emptyBet>
                  <div class="bet-type-col" *ngIf="betTypeGroupingTemplateItem.betTypeOutcomes">
                      <ng-container *ngFor="let i of arr(betTypeGroupingTemplateItem.betTypeOutcomes.length); let j = index">
                          <ng-container *ngIf="j<3">
                            <span class="sbv" *ngIf="betTypeGroupingTemplateItem.sbvDisplayType != sbvDisplayTypeEnum.NoSbv && ((j==0 && betTypeGroupingTemplateItem.betTypeOutcomes.length> 2) || (j==1 && betTypeGroupingTemplateItem.betTypeOutcomes.length< 3))">-</span>
                              <span class="locked disabled offline"  [attr.data-market]="betTypeGroupingTemplateItem.betTypeOutcomes[j].mobileShowType == betTypeOutcomeShowTypeEnum.BTOShortName? betTypeGroupingTemplateItem.betTypeOutcomes[j].shortName: betTypeGroupingTemplateItem.betTypeOutcomes[j].name">
                                <i class="icon icon-ex-sm icon-lock"></i>
                              </span>
                          </ng-container>
                      </ng-container>
                  </div>
              </ng-template>
            </ng-container>

        </div>
    </div>

    <div class="col col-bets">
        <div class="expand-event" (click)="showDetail(event)">+{{event.betsCount}}</div>
    </div>


</article>
